<div class="form-block block-blue amb-10" *ngIf="mode == elementMode.Definition">
  <div class="header">
        <span><i class="fa-solid fa-hand-pointer"></i>{{ translationManager.getTranslation('Поље') }} - {{
          translationManager.getTranslation('Селекција вредности') }}</span>
    <div class="actions" *ngIf="state == viewState.Create || state == viewState.Edit">
      <div>
        <a href="javascript:;" [title]="translationManager.getTranslation('Обриши елемент')"
           (click)="delete()"><i class="far fa-trash-alt tc-red"></i></a>
      </div>
    </div>
    <div class="element-orders">
      <div>
                <span>
                    <span class="element-order">
                        <a href="javascript:;" *ngIf="showOrderUp" [title]="translationManager.getTranslation('Промени редослед елементу на горе')" (click)="_element?.onElementOrder && _element?.onElementOrder(_element, elementOrderDirection.Up)"><i class="fa-solid fa-angle-up"></i></a>
                    </span>
                    <span class="element-order">
                        <a href="javascript:;" *ngIf="showOrderDown" [title]="translationManager.getTranslation('Промени редослед елементу на доле')" (click)="_element?.onElementOrder && _element?.onElementOrder(_element, elementOrderDirection.Down)"><i class="fa-solid fa-angle-down"></i></a>
                    </span>
                </span>
      </div>
    </div>
  </div>
  <div class="content">
    <div class="form-element"
         [ngClass]="{ 'error': form.elements['name'].error.required || form.elements['name'].error.invalid }">
      <label>{{ translationManager.getTranslation('Назив') }}</label>
      <div class="content" *ngIf="state === viewState.Create || state === viewState.Edit">
        <input type="text" [(ngModel)]="form.elements['name'].value" maxlength="100">
      </div>
      <div class="content" *ngIf="state === viewState.Details">
        <div class="static">
          <span>{{ form.elements['name'].value | appvalue }}</span>
        </div>
      </div>
      <div class="errors">
                <span *ngIf="form.elements['name'].error.required">
                    <i class="fas fa-times-circle"></i>{{ translationManager.getTranslation('Поље је обавезно за унос')
                  }}</span>
      </div>
    </div>
    <div class="form-element">
      <label><input type="checkbox" [(ngModel)]="form.elements['isMandatory'].value"
                    [disabled]="state == viewState.Details"> {{ translationManager.getTranslation('Да ли је поље
        обавезно за унос (Да/Не)') }}</label>
    </div>
    <div>
      <div>
        <div class="element-title solid"><span>{{ translationManager.getTranslation('Доступне вредности за
          селекцију') }}</span></div>
      </div>
      <div class="elements-no-content"
           *ngIf="!form.elements['definition'].value || form.elements['definition'].value.length == 0">
        <span>{{ translationManager.getTranslation('Без дефинисаних вредности за селекцију') }}</span>
      </div>
      <div>
        <div class="form-element amb-5" *ngFor="let item of form.elements['definition'].value">
          <div class="content with-action" *ngIf="state === viewState.Create || state === viewState.Edit">
            <input type="text" [(ngModel)]="item.value" maxlength="100">
            <div class="action" *ngIf="state === viewState.Create || state === viewState.Edit">
              <a href="javascript:;" class="red"
                 [title]="translationManager.getTranslation('Обриши вредност за селекцију')"
                 (click)="deleteSelectionValue(item)">
                <i class="far fa-trash-alt"></i>
              </a>
            </div>
          </div>
          <div class="content" *ngIf="state === viewState.Details">
            <div class="static">
              <span>{{ item.value | appvalue }}</span>
            </div>
          </div>
        </div>
        <div class="form-element" [ngClass]="{ 'error': form.elements['definition'].error.required }">
          <div class="errors">
                        <span *ngIf="form.elements['definition'].error.required">
                            <i class="fas fa-times-circle"></i>{{ translationManager.getTranslation('Једна или више
                          вредности за селекцију су обавезне за унос') }}</span>
          </div>
        </div>
      </div>
      <div *ngIf="state === viewState.Create || state === viewState.Edit">
        <div class="rich-icon-actions"><a href="javascript:;"
                                          [title]="translationManager.getTranslation('Додај нову вредност за селекцију')"
                                          (click)="addSelectionValue()"><i class="fa-solid fa-circle-plus"></i></a></div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="mode == elementMode.Execution">
  <div class="form-element"
       [ngClass]="{ 'error': formValue.elements['value'].error.required || formValue.elements['value'].error.invalid }">
    <label>{{ form.elements['name'].value }}</label>
    <div class="content" *ngIf="state === viewState.Create || state === viewState.Edit">
      <select [(ngModel)]="formValue.elements['value'].value">
        <option></option>
        <option *ngFor="let item of form.elements['definition'].value" [value]="item.id">{{ item.value }}</option>
      </select>
    </div>
    <div class="content" *ngIf="state === viewState.Details">
      <div class="static">
        <span>{{ formValue.elements['valueName'].value | appvalue }}</span>
      </div>
    </div>
    <div class="errors">
            <span *ngIf="formValue.elements['value'].error.required">
                <i class="fas fa-times-circle"></i>{{ translationManager.getTranslation('Поље је обавезно за унос')
              }}</span>
    </div>
  </div>
</div>
